import { forwardRef } from 'react'
import {
  Heading as ThemeUIHeading,
  HeadingProps as ThemeUIHeadingProps,
} from 'theme-ui'

export type HeadingProps = ThemeUIHeadingProps & {
  children: HTMLHeadingElement | string
}

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ children, ...rest }, ref) => (
    <ThemeUIHeading ref={ref} {...rest}>
      {children}
    </ThemeUIHeading>
  )
)
